import Header from './Header/Header';
import Steps from './Steps/Steps';
import Stats from './Stats/Stats';
import Reviews from './Reviews/Reviews';
import Section from './Section/Section';
import Pricing from './Pricing/Pricing';
import Footer from './Footer/Footer';
import CarForm from './Forms/CarForm';
import Images from './Images/Images';

export { Header, Steps, Stats, Reviews, Section, Pricing, Footer, CarForm, Images };



// WEBPACK FOOTER //
// ./src/components/ui/index.js